<template>
	<div>
		<a-page-header style="background: #fff;" title="会员类型" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'会员类型'}]}}">
			<template slot="extra">
		<!-- 		<a-button type="primary" @click="addModal = true">
					添加会员类型
				</a-button> -->
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :loading="loading">
					<span slot="memberEnough" slot-scope="memberEnough">
						{{memberEnough}} 元
					</span>
					<span slot="memberSendIntegral" slot-scope="memberSendIntegral">
						{{memberSendIntegral}} 折
					</span>
					<span slot="memberLvStatus" slot-scope="memberLvStatus">
						<a-tag v-if="memberLvStatus == true" color="green">开启</a-tag>
						<a-tag v-if="memberLvStatus == false" color="orange">关闭</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<!-- <a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm> -->
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加会员类型弹出 -->
		<a-modal title="添加会员类型" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="会员等级名称" prop="memberLvName">
					<a-input v-model="addForm.memberLvName" />
				</a-form-model-item>
				<a-form-model-item label="会员等级memberLv" prop="memberLv">
					<a-radio-group v-model="addForm.memberLv" button-style="solid">
						<a-radio-button :value="1">普通会员</a-radio-button>
						<a-radio-button :value="2">初级会员</a-radio-button>
						<a-radio-button :value="3">中级会员</a-radio-button>
						<a-radio-button :value="4">高级会员</a-radio-button>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="满足消费金额" prop="memberEnough">
					<a-input v-model="addForm.memberEnough" suffix="元"></a-input>
				</a-form-model-item>
				<a-form-model-item label="积分赠送比例" prop="memberSendIntegral">
					<a-input v-model="addForm.memberSendIntegral" suffix="%"></a-input>
				</a-form-model-item>
				<a-form-model-item label="开启状态" prop='memberLvStatus'>
					<a-switch checked-children="开启" un-checked-children="关闭" v-model="addForm.memberLvStatus" default-checked />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 编辑会员类型弹出 -->
		<a-modal title="编辑会员类型" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="修改" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="会员等级名称" prop="memberLvName">
					<a-input v-model="editForm.memberLvName" />
				</a-form-model-item>
				<a-form-model-item label="会员等级" prop="memberLv">
					<a-radio-group v-model="editForm.memberLv" :disabled="true">
						<a-radio-button :value="1">普通会员</a-radio-button>
						<a-radio-button :value="2">初级会员</a-radio-button>
						<a-radio-button :value="3">中级会员</a-radio-button>
						<a-radio-button :value="4">高级会员</a-radio-button>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="满足消费金额" prop="memberEnough">
					<a-input v-model="editForm.memberEnough" suffix="元" :disabled="editForm.id == 10"></a-input>
				</a-form-model-item>
				<a-form-model-item label="享受折扣" prop="memberSendIntegral">
					<a-input v-model="editForm.memberSendIntegral" suffix="折" :disabled="editForm.id == 10"></a-input>
				</a-form-model-item>
				<a-form-model-item label="开启状态" prop='memberLvStatus'>
					<a-switch checked-children="开启" un-checked-children="关闭" v-model="editForm.memberLvStatus" default-checked  :disabled="editForm.id == 10" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '会员名称',
			dataIndex: 'memberLvName',
			scopedSlots: {
				customRender: 'memberLvName'
			},
		},
		{
			title: '会员等级',
			dataIndex: 'memberLv',
			scopedSlots: {
				customRender: 'memberLv'
			},
		},
		{
			title: '满足消费金额',
			dataIndex: 'memberEnough',
			scopedSlots: {
				customRender: 'memberEnough'
			},
		},
		{
			title: '享受折扣',
			dataIndex: 'memberSendIntegral',
			scopedSlots: {
				customRender: 'memberSendIntegral'
			},
		},
		{
			title: '开启状态',
			dataIndex: 'memberLvStatus',
			scopedSlots: {
				customRender: 'memberLvStatus'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				addForm: {
					memberLvStatus: true
				},
				editModal: false,
				editForm: {},
				addModal: false,
				loading: false,
				addRules: {
					memberLvName: [{
						required: true,
						message: '请填写会员等级名称',
						trigger: 'blur'
					}],
					memberLv: [{
						required: true,
						message: '请选择会员等级',
						trigger: 'change'
					}],
					memberEnough: [{
						required: true,
						message: '请填写满足消费金额',
						trigger: 'blur'
					}],
					memberSendIntegral: [{
						required: true,
						message: '请填写积分赠送比例',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			toDetail(id) {
				this.memberLvId = id
				this.$http.post('/admin/index.php/admin/User/adminLevelInfo', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					}
				})
			},

			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/User/adminLevelSave', {
							id: this.memberLvId,
							memberLvName: this.editForm.memberLvName,
							memberLv: this.editForm.memberLv,
							memberEnough: this.editForm.memberEnough,
							memberSendIntegral: this.editForm.memberSendIntegral,
							memberLvStatus: this.editForm.memberLvStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('修改成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/User/adminLevelSave', {
							memberLvName: this.addForm.memberLvName,
							memberLv: this.addForm.memberLv,
							memberEnough: this.addForm.memberEnough,
							memberSendIntegral: this.addForm.memberSendIntegral,
							memberLvStatus: this.addForm.memberLvStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/User/adminLevelDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getList() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/User/adminLevelList').then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
</style>
